import React from "react";
import style from "css/hotdesking.module.css";
import PlanCanvas from "./PlanCanvas";
import { useTranslation } from "react-i18next";

function Content({
  bookCnt,
  resourceCnt,
  bookList,
  resourceList,
  findInfo,
  isFind,
  setIsFind,
  location,
  isRefresh,
  setIsRefresh,
  onShowBook,
  onRefreshBook,
  onError,
  date,
  time,
  serverDate,
  setTime,
  resource,
  setResource,
}) {
  const { t } = useTranslation();
  return (
    <section className={style.content_section}>
      <section className={style.count_section}>
        <SeatCount
          title={t("HOTDESKING.SEARCH.TITLE.AVAILABLE_SEATS")}
          cnt={location ? resourceCnt - bookCnt : 0}
        />
        <span className={style.count_divider} />
        <SeatCount
          title={t("HOTDESKING.SEARCH.TITLE.RESERVED_SEATS")}
          cnt={location ? bookCnt : 0}
        />
      </section>
      <PlanCanvas
        bookList={bookList}
        resourceList={resourceList}
        bookInfo={findInfo}
        isFind={isFind}
        setIsFind={setIsFind}
        location={location}
        isRefresh={isRefresh}
        setIsRefresh={setIsRefresh}
        onShowBook={onShowBook}
        onRefreshBook={onRefreshBook}
        onError={onError}
        date={date}
        time={time}
        serverDate={serverDate}
        setTime={setTime}
        resource={resource}
        setResource={setResource}
      />
    </section>
  );
}

export default Content;

function SeatCount({ title, cnt }) {
  return (
    <div className={style.count_item}>
      <p className={style.count_title}>{title}</p>
      <p className={style.count_content}>{cnt}</p>
    </div>
  );
}
